export default __webpack_public_path__ + "static/media/blog-1.ad1d5dcf.png";